// extracted by mini-css-extract-plugin
export default {"label":"label_label__yceSt","dark":"label_dark__SEJa3","light":"label_light__xJZB5","green":"label_green__HJnjM"};